import {PaymentFileInfo} from './payment-file-info.model';

export class PaymentDisplayAggregateInfo {
    hasPayments: boolean;
    possibleOutstandingPaymentFiles: boolean;
    paymentFileInfos: PaymentFileInfo[];

    constructor(hasPayments: boolean, possibleOutstandingPaymentFiles: boolean, paymentFileInfos: PaymentFileInfo[]) {
        this.hasPayments = hasPayments;
        this.possibleOutstandingPaymentFiles = possibleOutstandingPaymentFiles;
        this.paymentFileInfos = paymentFileInfos;
    }
}
